import { Flex, Image } from '@chakra-ui/react';
import { Integration_Names_Enum } from '@main/graphql/types.generated';
import { getRegisteredIntegrationConnector } from '@main/integrations/registry/connectors';
import { useAssetUrl } from '@main/shared/browser';

export const IntegrationLogo = ({ name }: { name: Integration_Names_Enum }) => {
  const assetUrl = useAssetUrl();
  const connector = getRegisteredIntegrationConnector(name);
  const logoUrl = assetUrl(connector.logoPath);

  return (
    <Flex
      align="center"
      justify="center"
      shrink={0}
      w="72px"
      h="72px"
      p={4}
      borderRadius="base"
      bg="gray.50"
    >
      <Image w="full" src={logoUrl} />
    </Flex>
  );
};
